document.addEventListener('DOMContentLoaded', () => {
  if(document.getElementById('shopify-app-init') != null){
    var data = document.getElementById('shopify-app-init').dataset;
    var host = new URLSearchParams(window.location.search).get('host');
    var AppBridge = window['app-bridge'];
    var createApp = AppBridge.default;
    window.app = createApp({
      apiKey: data.apiKey,
      shopOrigin: data.shopOrigin,
      host: host,
    });

    var actions = AppBridge.actions;
    var TitleBar = actions.TitleBar;
    TitleBar.create(app, {
      title: data.page,
    });
  }
});
